import Widgets                from "../widget/Widgets";
import RecordTemplateId       from "./RecordTemplateId";
import RecordTemplateName     from "./RecordTemplateName";
import RecordTemplateRevision from "./RecordTemplateRevision";

class RecordTemplate {
  constructor(
    private readonly _id: RecordTemplateId = new RecordTemplateId(),
    private readonly _revision: RecordTemplateRevision = new RecordTemplateRevision(),
    private readonly _name: RecordTemplateName = new RecordTemplateName(),
    private readonly _widgets: Widgets = new Widgets()
  ) {
  }

  get id() {
    return this._id;
  }

  get revision() {
    return this._revision;
  }

  get name() {
    return this._name;
  }

  get widgets() {
    return this._widgets;
  }
}

export default RecordTemplate;
